import React, { useState } from "react";
import { AdminService } from "src/domain/AdminService";
import AppInputFormik from "src/commun/composants/formulaire/formik/fields/AppInputFormik";
import { useFormikContext } from "formik";
import AppTextareaFormik from "src/commun/composants/formulaire/formik/fields/AppTextareaFormik";
import AppCheckboxFormik from "src/commun/composants/formulaire/formik/fields/AppCheckboxFormik";
import AppDropdownCheckboxFormik from "src/commun/composants/formulaire/formik/fields/AppDropdownCheckboxFormik";
import { AppSelectOption } from "src/commun/composants/formulaire/AppSelect/AppSelect";
import { useAppText } from "src/commun/composants/AppText";

export type AdminServiceFormContentProps = {
  accessGroups: AppSelectOption[];
  delete(): void;
};

const AdminServicesFormContent = ({accessGroups, delete: onDelete}: AdminServiceFormContentProps) => {
  const { submitCount, submitForm,} = useFormikContext<AdminService>();
  const [showConfirmButton, setShowConfirmButton] = useState(false);
  const { tString } = useAppText();
  const supprimer = () => {
    // Call the delete function passed as a prop
    onDelete();
  };
  return (
    <>
      <div className="input mt-3 mb-2 mr-5" style={{ display: "inline-block", width: "300px" }}>
        <AppInputFormik name="code" formulaireSoumis={submitCount > 0} isRequired={false}/>
        <label>{tString("administration.services.serviceCode")}</label>
      </div>

      <div className="input mt-3 mb-2 mr-5" style={{ display: "inline-block", width: "80px" }}>
        <AppInputFormik name="rank" formulaireSoumis={submitCount > 0}/>
        <label>{tString("administration.services.rank")}</label>
      </div>

      <div className="input mt-3 mb-2 mr-5" style={{ display: "inline-block", width: "300px" }}>
        <AppInputFormik name="labelFr" formulaireSoumis={submitCount > 0} isRequired={false}/>
        <label>{tString("administration.services.labelFr")}</label>
      </div>

      <div className="input mt-3 mb-2 mr-5" style={{ display: "inline-block", width: "300px" }}>
        <AppInputFormik name="labelEn" formulaireSoumis={submitCount > 0} isRequired={false}/>
        <label>{tString("administration.services.labelEn")}</label>
      </div>

      <div className="input mt-3 mb-2 mr-5" style={{ display: "inline-block", width: "300px" }}>
        <AppInputFormik name="labelDe" formulaireSoumis={submitCount > 0} isRequired={false}/>
        <label>{tString("administration.services.labelDe")}</label>
      </div>
      <br/>
      <div className="textarea mt-3 mb-2 mr-5" style={{ display: "inline-block" }}>
        <AppTextareaFormik name="descriptionFr" formulaireSoumis={submitCount > 0} maxlength={10000} isRequired={false}/>
        <label>{tString("administration.services.descriptionFr")}</label>
      </div>

      <div className="textarea mt-3 mb-2 mr-5" style={{ display: "inline-block" }}>
        <AppTextareaFormik name="descriptionEn" formulaireSoumis={submitCount > 0} maxlength={10000} isRequired={false}/>
        <label>{tString("administration.services.descriptionEn")}</label>
      </div>

      <div className="textarea mt-3 mb-2 mr-5" style={{ display: "inline-block" }}>
        <AppTextareaFormik name="descriptionDe" formulaireSoumis={submitCount > 0} maxlength={10000} isRequired={false}/>
        <label>{tString("administration.services.descriptionDe")}</label>
      </div>
      <br/>
      <div className="input mt-3 mb-2 mr-5" style={{ display: "inline-block", width: "300px" }}>
        <AppInputFormik name="url" formulaireSoumis={submitCount > 0} isRequired={false}/>
        <label>{tString("administration.services.url")}</label>
      </div>

      <div className="input mt-3 mb-2 mr-5" style={{ display: "inline-block", width: "300px" }}>
        <AppInputFormik name="urlAffilie" formulaireSoumis={submitCount > 0} isRequired={false}/>
        <label>{tString("administration.services.urlAffilie")}</label>
      </div>

      <div className="input mt-3 mb-2 mr-5" style={{ display: "inline-block", width: "300px" }}>
        <AppInputFormik name="urlInterne" formulaireSoumis={submitCount > 0} isRequired={false}/>
        <label>{tString("administration.services.urlInterne")}</label>
      </div>

      <div className="input mt-3 mb-2 mr-5" style={{ display: "inline-block", width: "300px" }}>
        <AppInputFormik name="urlSubscription" formulaireSoumis={submitCount > 0} isRequired={false}/>
        <label>{tString("administration.services.urlSubscription")}</label>
      </div>

      <div>
        <div className="mt-3 mb-2" style={{ display: "inline-block", marginRight: "30px", border: "1px solid #d7dce0", padding: "5px" }}>
          <AppCheckboxFormik
            name="displayedIfAbsent"
            value={"false"}
            label={tString("administration.services.displayedIfAbsent")}/>
        </div>
        <div className="mt-3 mb-2" style={{ display: "inline-block", marginRight: "30px", border: "1px solid #d7dce0", padding: "5px" }}>
          <AppCheckboxFormik
            name="openInNewTab"
            value={"false"}
            label={tString("administration.services.openInNewTab")}/>
        </div>
        <div className="mt-3 mb-2" style={{ display: "inline-block", marginRight: "30px", border: "1px solid #d7dce0", padding: "5px" }}>
          <AppCheckboxFormik
            name="flagNew"
            value={"false"}
            label={tString("administration.services.flagNew")}/>
        </div>
        <br/>
        <div className="mt-3 mb-2 mr-5" style={{ display: "inline-block" }}>
          <AppDropdownCheckboxFormik
            name={"accessGroups"}
            label={tString("administration.services.accessGroups")}
            options={accessGroups}
          />
        </div>
      </div>

      <div className="mt-3 mb-2 mr-5">
        {showConfirmButton ? (
          <>
            <input
              className={`btn__primary mt-3 btn--full--xs`}
              type="button"
              name="confirmDelete"
              onClick={() => {
                supprimer(); // Call the supprimer function here.
                setShowConfirmButton(false);
              }}
              style={{ backgroundColor: "red" }}
              value={"Confirmer la suppression"}
            />
          </>
        ) : (
          <>
            <input
              className={`btn__primary mt-3 btn--full--xs mr-5`}
              type="submit"
              name="valider"
              onClick={submitForm}
              value={"Sauvegarder"}
            />
            <input
              className={`btn__secondary mt-3 btn--full--xs`}
              type="button"
              name="supprimer"
              onClick={() => setShowConfirmButton(true)}
              value={"Supprimer"}
            />
          </>
        )}
      </div>

      <hr/>
    </>
  );
};

export default AdminServicesFormContent;